/**
 * Menu helper - now using the unified navigation configuration
 *
 * @deprecated Please import helpers from '@/config/navigation-adapters' directly
 * This file is kept for backward compatibility only
 */

import type { MenuProps } from "antd";
import type { ReactNode } from "react";
import { getMenuItems } from "@/routers/navigation-adapters";

// Function to find open and selected keys based on current path
export const findMenuKeys = (path: string) => {
  const items = getMenuItems();
  const openKeys: string[] = [];
  const selectedKeys: string[] = [];

  // Recursively find matching menu items
  const findMatchingKeys = (menuItems: typeof items, currentPath: string): boolean => {
    for (const item of menuItems) {
      if (item.url === currentPath) {
        selectedKeys.push(item.url);
        return true;
      }

      if (item.children) {
        for (const child of item.children) {
          if (child.url === currentPath) {
            selectedKeys.push(child.url);
            openKeys.push(item.url);
            return true;
          }

          if (child.children) {
            for (const grandChild of child.children) {
              if (grandChild.url === currentPath) {
                selectedKeys.push(grandChild.url);
                openKeys.push(item.url);
                return true;
              }
            }
          }
        }
      }
    }
    return false;
  };

  findMatchingKeys(items, path);

  return { openKeys, selectedKeys };
};

export const buildMenuItems = (): MenuProps["items"] => {
  const items = getMenuItems();

  // Convert to Antd Menu format
  type AntdLikeMenuItem = {
    key: string;
    icon?: ReactNode;
    label: ReactNode;
    children?: AntdLikeMenuItem[];
  };

  const convertToAntdFormat = (menuItems: typeof items): MenuProps["items"] => {
    const toAntdLike = (nodes: typeof items): AntdLikeMenuItem[] => {
      return nodes.map((item) => {
        const menuItem: AntdLikeMenuItem = {
          key: item.url,
          icon: item.icon,
          label: item.title,
        };

        if (item.children && item.children.length > 0) {
          menuItem.children = item.children.map((child) => {
            const childItem: AntdLikeMenuItem = {
              key: child.url,
              label: child.title,
            };

            if (child.children && child.children.length > 0) {
              childItem.children = child.children.map((grandChild) => ({
                key: grandChild.url,
                label: grandChild.title,
              }));
            }

            return childItem;
          });
        }

        return menuItem;
      });
    };

    return toAntdLike(menuItems) as unknown as MenuProps["items"];
  };

  return convertToAntdFormat(items);
};
